import { defineMessages } from 'react-intl';

const scope = 'app.workspace.knowledge';

export default defineMessages({
  knowledgeMap: {
    id: `${scope}.knowledgeMap`,
    defaultMessage: 'Knowledge Map',
  },
  import: {
    id: `${scope}.import`,
    defaultMessage: 'Import',
  },
});
